module.exports = __webpack_public_path__ + "static/media/icon_select_img.bca988b7.svg";